import { Toggle } from '~/components/ui/toggle'
import { cn } from '~/lib/utils'
import { type SectionProps } from './constants'
import { Field, Textarea } from './controls'

// 채점 관련 입력: 결정형 토글·채점 척도·안내(guidance)·채점 로직. 안내는 척도와
// 로직 사이에 위치해 원본 순서·간격(space-y-6)을 그대로 보존하기 위해 함께 둔다.
export function ScoringPanel({ form, set, isDirty }: SectionProps) {
    return (
        <>
            {/* 결정형 토글 */}
            <div className='border-border bg-muted/40 flex items-center justify-between rounded-[var(--radius)] border p-3'>
                <div>
                    <span className='text-foreground text-sm font-bold'>
                        결정형 (채점 반영)
                    </span>
                    <p className='text-muted-foreground text-xs'>
                        규칙으로 자동 판정되는 항목이에요.
                    </p>
                </div>
                <div className='flex items-center gap-2'>
                    <span
                        className={cn(
                            'text-sm',
                            isDirty('isDeterministic')
                                ? 'text-primary font-bold'
                                : 'text-foreground'
                        )}>
                        {form.isDeterministic ? '결정형' : '비결정형'}
                    </span>
                    <Toggle
                        aria-label='결정형 여부'
                        checked={form.isDeterministic}
                        onCheckedChange={(on) => set('isDeterministic', on)}
                    />
                </div>
            </div>

            {/* 채점 척도 (긴 텍스트) */}
            <Field label='채점 척도' dirty={isDirty('scoringScale')}>
                {(control) => (
                    <Textarea
                        {...control}
                        rows={4}
                        value={form.scoringScale}
                        dirty={isDirty('scoringScale')}
                        onChange={(v) => set('scoringScale', v)}
                    />
                )}
            </Field>

            {/* 안내 (긴 텍스트) */}
            <Field label='안내(guidance)' dirty={isDirty('guidance')}>
                {(control) => (
                    <Textarea
                        {...control}
                        rows={6}
                        value={form.guidance}
                        dirty={isDirty('guidance')}
                        onChange={(v) => set('guidance', v)}
                    />
                )}
            </Field>

            {/* 채점 로직 (긴 텍스트, 채점 반영) */}
            <Field
                label='채점 로직 (채점 반영)'
                dirty={isDirty('scoringLogic')}>
                {(control) => (
                    <Textarea
                        {...control}
                        rows={6}
                        value={form.scoringLogic}
                        dirty={isDirty('scoringLogic')}
                        onChange={(v) => set('scoringLogic', v)}
                    />
                )}
            </Field>
        </>
    )
}
